export const NOTIFICATION_DISPLAY_DURATION = 15; // 15 seconds
export const NOTIFICATION_MAX_VISIBLE = 3; // maximum 3 visible notifications at the same time
